import styled from 'styled-components';

const Styled = styled.div`
  .policies {
    margin-top: 8px;
    margin-bottom: 16px;
    font-size: 13px;
  }

  .action, .stripe-form {
    button {
        width: 100%;
    }
  }
`;
export default Styled;
